/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../components/Modal';
import { activateCardScreens } from '../../screens/Card/constants';
import EnterCardCode from '../../screens/Card/enterCardCode';
import CardBlocked from '../../screens/Card/cardBlocked';

const ActivateCardModal = ({ hide }) => {
  const [currentScreen, setCurrentScreen] = useState(activateCardScreens.ENTER_CVV);

  const interestPaymentFlow = useMemo(
    () => [
      {
        screen: activateCardScreens.ENTER_CVV,
        component: <EnterCardCode openScreen={setCurrentScreen} hidePopup={hide} />,
      },
      {
        screen: activateCardScreens.CONTACT_SUPPORT,
        component: <CardBlocked />,
      },
    ],
    [hide]
  );

  const SelectedComponent = useMemo(
    () => interestPaymentFlow.find((item) => item.screen === currentScreen).component,
    [interestPaymentFlow, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal contentStyle={{ maxHeight: '25rem' }}>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

ActivateCardModal.propTypes = {
  hide: PropTypes.func,
};

export default ActivateCardModal;
